import { tagAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tagAnatomy.keys);

const baseStyle = definePartsStyle({
    container: {
        fontWeight: 'medium',
        borderRadius: 'full',
        textTransform: 'capitalize',
        verticalAlign: 'middle'
    }
});

const variants = {
    status: definePartsStyle({
        container: {
            fontWeight: 'medium',
            borderRadius: 'full',
            textTransform: 'capitalize',
            px: 3,
            py: 1
        }
    }),
    outline: definePartsStyle({
        container: {
            textTransform: 'uppercase'
        }
    })
};

const sizes = {
    xs: definePartsStyle({
        container: {
            px: 1.5,
            py: 1,
            fontSize: '10px'
        }
    }),
    sm: definePartsStyle({
        container: {
            px: 1.5,
            py: 0.5,
            fontSize: 'xs'
        }
    }),
    md: definePartsStyle({
        container: {
            px: 2,
            py: 1,
            fontSize: 'sm'
        }
    })
};

export const tagTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes
});
